import React from 'react';
import { Image } from 'semantic-ui-react'

const covidDescription = () => {

    return (
        <div style={{ paddingBottom: '100px' }}>
            <div className='ui grid'>
                <div className="centered row">
                    <div className="sixteen wide column centered">
                        <h1 className="ui header">Ecuador COVID-19 dashboard</h1>
                    </div>
                </div>
                <div className='row'>
                    <div className="sixteen wide column">
                        <h2 className="ui header">Description</h2>
                    </div>
                </div>
                <div className='row'>
                    <div className="sixteen wide column">
                        <p>
                            Dashboard that presents COVID-19 data. It uses Python's library Dash for implementation.
                        </p>
                    </div>
                </div>
                <div className='centered row'>
                    <div className="sixteen wide column center aligned">
                        <Image src={require("../../images/ecuacovid.PNG")} size='medium' centered />
                    </div>
                </div>
                <div className='spaced row'>
                    <div className="sixteen wide column center aligned">
                        <a href="http://ecuacovid.herokuapp.com/">
                            <div className='ui small button'>
                                <i className='external alternate icon'></i> Check it out
                            </div>
                        </a>
                        <a href="https://github.com/jomavera/dashboardData">
                            <div className='ui small button'>
                                <i className='github icon'></i> Repo
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default covidDescription;